import styles from '../index.module.scss';

export default function SubTitle({ title, style }: { title: string; style?: any }) {
  return (
    <div className={styles.subTitle} style={style}>
      {title}
    </div>
  );
}
